import Vue from 'vue'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#152031',
    secondary: '#152031',
    accent: '#cf142b',
    error: '#EB030B'
  },
  options: {
    customProperties: true,
    minifyTheme: function (css) {
      return process.env.NODE_ENV === 'production'
        ? css.replace(/[\s|\r\n|\r|\n]/g, '')
        : css
    }
  }
  // themeCache: {
  //   new LRU({
  //     max: 10,
  //     maxAge: 1000 * 60 * 60 // 1 hour
  //   })
  // }
})
